require("./sass/styles.scss");
var $ = require('jquery');
var Isotope = require("isotope-layout");
var Slick = require("slick-carousel");
var Magnific = require("magnific-popup");

// var MTIProjectId='6cfc9f96-7f6e-492c-b19a-c10cf8bf6797';
//  (function() {
//         var mtiTracking = document.createElement('script');
//         mtiTracking.type='text/javascript';
//         mtiTracking.async='true';
//          mtiTracking.src='mtiFontTrackingCode.js';
//         (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
//    })();

$(function() {
    $(".items--pack").each(function() {
        var iso = new Isotope( '.items--pack', {
            // percentPosition: true,
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-sizer'
            }
        });
    })
    $(".slides").each(function() {
        $(this).slick({
            dots:true,
            appendArrows: $(this).parents('.section_slider'),
            appendDots: $(this).parents('.section_slider'),
            infinite: false,
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.77 79.07"><defs><style>.cls-1{fill:#fff;opacity:0.6;}</style></defs><title>white_arrow_right</title><path class="cls-1" d="M8637.21,1292l-7.88,0,16.7-42c-7.32-14.63-17.85-35.6-18.72-37.08h8.28l18.49,36.74Z" transform="translate(-8627.31 -1212.95)"/></svg></button>',
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.77 79.07"><defs><style>.cls-1{fill:#fff;opacity:0.6;}</style></defs><title>white_arrow_right</title><path class="cls-1" d="M8637.21,1292l-7.88,0,16.7-42c-7.32-14.63-17.85-35.6-18.72-37.08h8.28l18.49,36.74Z" transform="translate(-8627.31 -1212.95)"/></svg></button>'
        }).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
            $(".slidecontents", $(this).parent().parent()).slick("slickGoTo", nextSlide);
        });
    });
    $(".slidecontents").each(function() {
        $(this).slick({
            dots: false,
            arrows:false,
            fade: true,
            cssEase: 'linear'
        })
    })
    $(".menu_button").click(function() {
        $("header").toggleClass("sitenav--open");
    });
    $(".sitenav .search a").click(function(e) {
        e.preventDefault();
        $(".searchbox").toggle();
    })
    //TODO: URL-Loader
    $(".item_popup").each(function() {
        $(this).magnificPopup({
            type: 'ajax',
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in',
            // alignTop: true,
            overflowY: 'scroll',
            callbacks: {
                ajaxContentAdded: function() {
                    $(".slides", $(".mfp-content")).each(function() {
                        $(this).slick({
                            dots:true,
                            appendArrows: $(this).parents('.section_slider'),
                            appendDots: $(this).parents('.section_slider'),
                            infinite: false,
                            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.77 79.07"><defs><style>.cls-1{fill:#fff;opacity:0.6;}</style></defs><title>white_arrow_right</title><path class="cls-1" d="M8637.21,1292l-7.88,0,16.7-42c-7.32-14.63-17.85-35.6-18.72-37.08h8.28l18.49,36.74Z" transform="translate(-8627.31 -1212.95)"/></svg></button>',
                            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.77 79.07"><defs><style>.cls-1{fill:#fff;opacity:0.6;}</style></defs><title>white_arrow_right</title><path class="cls-1" d="M8637.21,1292l-7.88,0,16.7-42c-7.32-14.63-17.85-35.6-18.72-37.08h8.28l18.49,36.74Z" transform="translate(-8627.31 -1212.95)"/></svg></button>'
                        });
                    });
                }
            }
        });
    })
})

var sections = [];
var activesection = null;
var sectionoffset = 0;
var viewportheight = 0;
var headerheight = 0;

function updateActiveSection() {
    var currentscroll = $(window).scrollTop();
    var index = 0;
    $(sections).each(function(index, obj) {
        // console.log(obj.top);
        // console.log( (currentscroll + sectionoffset) );
        if(obj.top <= (currentscroll + sectionoffset)) {
            activesection = index;
        }
        index++;
    });
    // $("section.section").removeClass("section--active");
    // if(activesection)
    //     activesection.addClass("section--active");
    // console.log(activesection);

    if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
        $(".section--continue").addClass("section--hidedown");
    } else {
        $(".section--continue").removeClass("section--hidedown");
    }

    if(
        ($(window).scrollTop()  > ($(document).height() / 2) ) ||
        ($(window).scrollTop() + $(window).height() > $(document).height() - 100)
    ) {
        $(".section--continue").addClass("section--showup");
    } else {
        $(".section--continue").removeClass("section--showup");
    }
}

function indexSections() {
    // console.log("reindex");
    sections = [];
    $("section.section").not(".section--continue, .section--staticcontinue").each(function(index, obj) {
        // console.log(obj);
        // console.log($(obj).offset());
        sections.push({
            top: $(obj).offset().top,
            section: $(obj)
        })
    })
}

$(window).on("load resize", function(e) {
    sectionoffset = 120;//$("header").height();
    // console.log(sectionoffset);
    indexSections();
    updateActiveSection();
    viewportheight = $(window).height();
    headerheight = $("header").css("height");
}).on("scroll", function(e) {
    updateActiveSection();
}).on("load", function(e) {
    headerheight = parseInt($("header").css("height").replace("px", ""));
    if(location.hash) {
        var $scrolltarget = $(location.hash.replace("#jump", "#section"));
        var nextscroll = $scrolltarget.offset().top - headerheight;
        setTimeout(function() {
            $('html, body').animate({scrollTop: nextscroll}, 500);
        }, 1000);
    }
})

$(".continue").on("click", function(e) {
    e.preventDefault();
    var static = false;
    if($(this).parent().hasClass("section--staticcontinue")) {
        static = true;
    }
    var nextsection = null;
    if(activesection !== null && sections.length > activesection + 1) {
        nextsection = sections[activesection + 1].section;
    } else {
        nextsection = sections[0].section;
    }
    if(nextsection.length) {
        var currentscroll = $(window).scrollTop();
        var nextscroll = nextsection.offset().top - headerheight + 5;
        if(!static && nextscroll-currentscroll < viewportheight)
            nextscroll = currentscroll + viewportheight;
        $('html, body').animate({scrollTop: nextscroll}, 500);
    } else {
        var nextscroll = $(window).scrollTop() + viewportheight;
        $('html, body').animate({scrollTop: nextscroll}, 500);
    }
})
$(".totop").on("click", function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 500);
})


//////////////////
// WEBPACK FOOTER
// ./mysite/src/main.js
// module id = 20
// module chunks = 1